/* eslint-disable no-undef */
// import io from 'socket.io-client'
// const socket = io(process.env.REACT_APP_BUNKEY_SOCKET, {
// 	path: '/sockets',
// })
// export default socket
import io from 'socket.io-client'

let socket

const getInstance = () => {
  if (!socket) {
    socket = io(process.env.REACT_APP_BUNKEY_SOCKET, {
      path: '/sockets',
    })
  }
  return socket
}

export default class {
  constructor() {
    socket = getInstance()
  }

  static open = () => {
    socket = getInstance()
    socket.open()
  }

  static disconnect = () => {
    socket = getInstance()
    socket.disconnect(true)
    socket = null
  }

  static getInstance = () => {
    socket = getInstance()
    return socket
  }
}